"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _draftJs = require("draft-js");

var _parser = require("./parser");

var _lib = require("../../lib");

var _common = require("../../common");

require("./styles.css");

var _InputWrapper = _interopRequireDefault(require("../InputWrapper"));

var _Row = _interopRequireDefault(require("../Row"));

var _Column = _interopRequireDefault(require("../Column"));

var _Container = _interopRequireDefault(require("../Container"));

var _richTextEditor = require("../../constants/richTextEditor");

var _Decorators = _interopRequireDefault(require("./Decorators"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RichTextEditor =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RichTextEditor, _PureComponent);

  function RichTextEditor(props) {
    var _this;

    _classCallCheck(this, RichTextEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RichTextEditor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getBlockStyle", function (block) {
      var data = block.getData(); // textAligns

      var textAlign = data.get('textAlign');

      switch (textAlign) {
        case 'left':
          return 'text-align-left';

        case 'center':
          return 'text-align-center';

        case 'right':
          return 'text-align-right';

        case 'justify':
          return 'text-align-justify';

        default:
          return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getControlsOptions", function () {
      var controls = _this.props.controls;
      return _richTextEditor.CONTROLS.filter(function (o) {
        return controls.includes(o.label.toLowerCase());
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnLinkEntityOpen", function () {
      var value = _this.state.value;
      return _lib.draft.getSelectedText(value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTab", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault');
      var value = _this.state.value;
      var maxDepth = 4;

      var newState = _draftJs.RichUtils.onTab(e, value, maxDepth);

      if (value !== newState) {
        _this.handleOnChange(newState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyCommand", function (command) {
      var value = _this.state.value;

      var newState = _draftJs.RichUtils.handleKeyCommand(value, command);

      if (newState && value !== newState) {
        _this.handleOnChange(newState);

        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (state) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var editorState = _this.state.value;

      var _draft$extractEditorS = _lib.draft.extractEditorStateData(editorState, ['content']),
          currentContent = _draft$extractEditorS.content;

      var _draft$extractEditorS2 = _lib.draft.extractEditorStateData(state, ['content']),
          newContent = _draft$extractEditorS2.content;

      _this.setState({
        value: state,
        prevValue: state
      }, function () {
        if (callback) {
          callback(_this.state);
        }

        var _this$props = _this.props,
            name = _this$props.name,
            onChange = _this$props.onChange;

        if (onChange) {
          var outputFormat = _this.props.outputFormat;

          var _draft$extractContent = _lib.draft.extractContentStateData(newContent, ['plainText']),
              value = _draft$extractContent.plainText;

          if (outputFormat === 'markdown') {
            value = (0, _parser.stateToMarkdown)(newContent);
          }

          if (outputFormat === 'html') {
            value = (0, _parser.stateToHTML)(newContent);
          }

          if (!newContent.hasText()) {
            // set value to null if no text
            value = null;
          }

          if (currentContent !== newContent) {
            onChange(null, {
              name: name,
              value: value
            });
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var focus = _this.state.focus;

      if (!focus) {
        _this.setState({
          focus: true
        }, function () {
          var current = _this.innerRef.current;

          if (current) {
            current.focus();
          }

          var onClick = _this.props.onClick;

          if (onClick) {
            onClick();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      var focus = _this.state.focus;

      if (focus) {
        _this.setState({
          focus: false
        }, function () {
          var onBlur = _this.props.onBlur;

          if (onBlur) {
            onBlur();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [RichTextEditor.className];
      (0, _lib.addClassByPropName)(names, _this.state, ['focus']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "editorClassNames", function () {
      var names = ["".concat(RichTextEditor.className, "-Editor")];
      (0, _lib.addDefaultCSS)(names);
      return names.join(' ');
    });

    var _value = props.value;
    var newValue = RichTextEditor.getInitValue(props);
    _this.state = {
      prevProps: {
        value: _value
      },
      value: newValue,
      prevValue: null
    };
    _this.innerRef = _react.default.createRef();
    return _this;
  }

  _createClass(RichTextEditor, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          spellCheck = _this$props2.spellCheck,
          format = _this$props2.format,
          outputFormat = _this$props2.outputFormat,
          placeholder = _this$props2.placeholder,
          onChange = _this$props2.onChange,
          propsValue = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          name = _this$props2.name,
          rest = _objectWithoutProperties(_this$props2, ["innerRef", "spellCheck", "format", "outputFormat", "placeholder", "onChange", "value", "defaultValue", "name"]);

      var value = this.state.value;
      var focus = this.state.focus;
      var options = this.getControlsOptions();
      var classNames = this.classNames();
      var editorClassNames = this.editorClassNames();
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var richTextEditorRef = innerRef || this.innerRef;
      return _react.default.createElement(Wrapper, {
        className: classNames
      }, _react.default.createElement(_Row.default, {
        className: "MHub-RichTextEditor-Controls-Wrapper"
      }, _react.default.createElement(_Column.default, {
        as: _Row.default,
        between: true,
        col: 12
      }, _react.default.createElement(_Container.default, {
        noContent: true,
        basic: true
      }, _react.default.createElement(_Dropdown.default, {
        editorState: value,
        options: options.filter(function (o) {
          return o.data.type === 'BLOCK_STYLE' && (o.label.includes('Heading') || o.label.includes('Normal'));
        }),
        onChange: this.handleOnChange
      })), _react.default.createElement(_Container.default, {
        noContent: true,
        basic: true
      }, _react.default.createElement(_Controls.default, {
        editorState: value,
        options: options.filter(function (o) {
          return !o.label.includes('Heading') && !o.label.includes('Normal');
        }),
        onChange: this.handleOnChange
      })))), _react.default.createElement(_InputWrapper.default, _extends({}, rest, {
        className: editorClassNames,
        focus: focus,
        onClick: this.focus,
        onBlur: this.blur
      }), _react.default.createElement(_draftJs.Editor, {
        placeholder: placeholder,
        blockStyleFn: this.getBlockStyle,
        customStyleMap: _richTextEditor.STYLE_MAP,
        editorState: value,
        handleKeyCommand: this.handleKeyCommand,
        onChange: this.handleOnChange,
        onTab: this.handleOnTab,
        ref: richTextEditorRef,
        spellCheck: spellCheck
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value;
      var newValue = RichTextEditor.getInitValue(props, state);
      return {
        // Store the previous props in state
        prevProps: {
          value: value
        },
        value: prevProps.value !== value ? newValue : state.value
      };
    }
  }]);

  return RichTextEditor;
}(_react.PureComponent);

exports.default = RichTextEditor;

_defineProperty(RichTextEditor, "className", 'MHub-RichTextEditor');

_defineProperty(RichTextEditor, "propTypes", {
  as: _common.customPropTypes.as,
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  innerRef: _common.customPropTypes.ref,
  spellCheck: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  controls: _propTypes.default.arrayOf(_propTypes.default.oneOf(_richTextEditor.CONTROLS_OPTIONS)),
  format: _propTypes.default.oneOf(_richTextEditor.FORMAT_TYPES),
  outputFormat: _propTypes.default.oneOf(_richTextEditor.FORMAT_TYPES)
});

_defineProperty(RichTextEditor, "defaultProps", {
  as: null,
  value: null,
  defaultValue: null,
  name: null,
  onChange: null,
  onBlur: null,
  onClick: null,
  innerRef: null,
  spellCheck: false,
  placeholder: null,
  controls: _richTextEditor.CONTROLS_OPTIONS.map(function (o) {
    return o.toLowerCase();
  }),
  format: 'html',
  outputFormat: 'html'
});

_defineProperty(RichTextEditor, "refocusSelection", function (newState, state) {
  var _draft$extractEditorS3 = _lib.draft.extractEditorStateData(state, ['content', 'selection']),
      content = _draft$extractEditorS3.content,
      selection = _draft$extractEditorS3.selection;

  var _draft$extractContent2 = _lib.draft.extractContentStateData(content, ['blockMap']),
      blockMap = _draft$extractContent2.blockMap;

  var _draft$extractEditorS4 = _lib.draft.extractEditorStateData(newState, ['content']),
      newContent = _draft$extractEditorS4.content;

  var _draft$extractContent3 = _lib.draft.extractContentStateData(newContent, ['blocksArray']),
      newBlocksArray = _draft$extractContent3.blocksArray; // get offsets and focusKey using old state


  var _draft$extractSelecti = _lib.draft.extractSelectionStateData(selection, ['startKey', 'endOffset', 'focusKey']),
      startKey = _draft$extractSelecti.startKey,
      endOffset = _draft$extractSelecti.endOffset,
      focusKey = _draft$extractSelecti.focusKey; // get current block value using old state


  var currentBlockIndex = blockMap.keySeq().findIndex(function (k) {
    return k === startKey;
  }); // get new anchorkey using index ( which row is being edited )

  var currentBlock = newBlocksArray[currentBlockIndex];
  var anchorKey = (0, _lib.arrayHasItems)(newBlocksArray) && currentBlock ? currentBlock.getKey() : blockMap.last().getKey(); // create new SelectionState

  return _draftJs.EditorState.forceSelection(newState, new _draftJs.SelectionState({
    anchorKey: anchorKey,
    anchorOffset: endOffset,
    focusKey: focusKey,
    focusOffset: endOffset
  }));
});

_defineProperty(RichTextEditor, "getInitValue", function (props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var value = props.value,
      defaultValue = props.defaultValue,
      format = props.format;

  var newEditorState = _draftJs.EditorState.createEmpty(_Decorators.default);

  if (defaultValue && (0, _lib.isString)(defaultValue) || value && (0, _lib.isString)(value)) {
    var content = _draftJs.ContentState.createFromText(defaultValue || value);

    if (format === 'markdown') {
      content = (0, _parser.stateFromMarkdown)(defaultValue || value);
    }

    if (format === 'html') {
      content = (0, _parser.stateFromHTML)(defaultValue || value);
    }

    newEditorState = _draftJs.EditorState.createWithContent(content, _Decorators.default);

    if (state && state.prevValue && state.value.getCurrentContent().hasText()) {
      newEditorState = RichTextEditor.refocusSelection(newEditorState, state.prevValue);
    }
  }

  return newEditorState;
});